"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("./modules/router");
var select_1 = require("./modules/select");
var termsModal_1 = require("./modules/termsModal");
var cookie_1 = require("./modules/cookie");
router_1.default.on("ShopPageController@index", "shop/index");
router_1.default.on("CheckoutPageController@index", "checkout/index");
router_1.default.on("CheckoutPageController@confirmation", "checkout/confirmation");
router_1.default.on("LanguagePageController@index", "language/index");
router_1.default.on("CardUploadPageController@index", "upload/index");
termsModal_1.default.getInstance();
select_1.default.getInstance();
cookie_1.default.getInstance();
router_1.default.run();
